import {TextareaField} from 'evergreen-ui';
import React, {memo} from 'react';
import {useFormContext} from 'react-hook-form';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {OfferFormInput} from './OfferForm';


type CommentInputProps = {
    isSubmitting$: Observable<boolean>;
}
export const CommentInput = memo(({
                                      isSubmitting$,
                                  }: CommentInputProps
) => {
    const {register} = useFormContext<OfferFormInput>();
    const sending = useObservable(isSubmitting$, false);
    return (
        <TextareaField
            id='comments'
            {...register('comments')}
            label='Comments'
            maxWidth='48em'
            maxLength={2048}
            disabled={sending} />
    );
});
